import { render, staticRenderFns } from "./VueSuggestion.vue?vue&type=template&id=571c5eca&"
import script from "./VueSuggestion.vue?vue&type=script&lang=js&"
export * from "./VueSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports